/**
 * Mirrors the BE enum `OKIS.Domain.Shared.Inspections.InspectionProgressStep`. The numeric values must match the BE:
 * they are stored in the `Inspection.ProgressStep` DB column.
 */
export enum InspectionProgressStep {
	OrderView = 1,
	Questionnaire = 2,
	ActivityData = 3,
	Deficiency = 4,
	Conclusion = 5,
	Review = 6,
	Participant = 7,
	Sanction = 8,
}
